<template>
    <div id="pad-wrapper" class="animation-duration">
        <div class="row head">
            <div class="col-md-9">
                <h4>Список номеров</h4>
            </div>
            <div class="col-md-3">

            </div>
        </div>

        <div class="row">
            <div class="col-md-12">
                <v-card flat>
                    <v-card-text>
                        <div class="block mydatepicker">
                            <el-input placeholder="Поиск по номеру.." v-model="search" class="mysearch" style="width:125px;"></el-input>
                            <el-select v-model="selectSite" placeholder="Сайт" class="ml-1" clearable>
                                <el-option
                                        v-for="site in sites"
                                        :key="site"
                                        :label="site"
                                        :value="site">
                                </el-option>
                            </el-select>
                            <el-select v-model="selectProvider" placeholder="Поставщик" class="ml-1" clearable style="width:110px;">
                                <el-option
                                        v-for="provider in provides"
                                        :key="provider"
                                        :label="provider"
                                        :value="provider">
                                </el-option>
                            </el-select>
                            <el-date-picker
                                    v-model="rangeDates"
                                    class="ml-1"
                                    type="daterange"
                                    align="right"
                                    range-separator="-"
                                    start-placeholder="Начало"
                                    end-placeholder="Конец"
                                    @change="changeDates"
                                    :picker-options="pickerOptions2">
                            </el-date-picker>
                            <el-dropdown>
                                <el-button class="ml-1 mycsv">
                                    <v-icon size="24">cloud_download</v-icon>
                                </el-button>
                                <el-dropdown-menu slot="dropdown">
                                    <a :href="'/xlsxphones?format=xlsx&'+datesUrl+'&uid='+user.id" download><el-dropdown-item>Выгрузить в Excel</el-dropdown-item></a>
                                    <a :href="'/xlsxphones?format=csv&'+datesUrl+'&uid='+user.id" download><el-dropdown-item>Выгрузить в CSV</el-dropdown-item></a>
                                </el-dropdown-menu>
                            </el-dropdown>
                            <el-button class="ml-1" @click="changeDates" style="padding-top: 9px; padding-bottom: 5px;">
                                <v-icon size="24">refresh</v-icon>
                            </el-button>
                        </div>
                        <v-data-table
                                :headers="headers"
                                :items="filteredPhones"
                                :loading="isLoading"
                                :sort-by="['visit_time']"
                                :sort-desc="[true]"
                                multi-sort
                                loading-text="Загрузка..."
                        >
                            <v-progress-linear slot="progress" color="blue" indeterminate></v-progress-linear>
                            <template v-slot:item.buttons="{ item }">
                                <el-button plain icon="el-icon-view" circle size="mini" @click="phoneInfo(item)"></el-button>
                            </template>
                            <template slot="no-data">
                                <div v-show="!isLoading">
                                    Нет номеров за этот период
                                </div>

                            </template>
                        </v-data-table>
                    </v-card-text>
                </v-card>
            </div>
        </div>
        <v-dialog v-model="dialog" transition="dialog-bottom-transition">
            <v-card>
                <v-toolbar dark color="rgb(88, 87, 87)">
                    <v-btn icon dark @click="dialog = false">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                    <v-toolbar-title>Детальная информация</v-toolbar-title>
                    <div class="flex-grow-1"></div>
                    <v-toolbar-items>

                    </v-toolbar-items>
                </v-toolbar>
                <v-card-text v-if="!isLoadingDialog">
                    <div class="row">
                        <div class="col-md-4">
                            <v-list three-line subheader>
                                <v-list-item>
                                    <v-list-item-content>
                                        <v-list-item-title class="mb-4"><v-icon size="16">person</v-icon> Гость #{{phone.visit_id}}</v-list-item-title>
                                        <v-list-item-title class="mb-4"><v-icon size="16">phone</v-icon> Телефон: {{phone.phone}}</v-list-item-title>
                                        <v-list-item-title class="mb-4"><v-icon size="16">public</v-icon> Сайт: {{phone.site}}</v-list-item-title>
                                        <v-list-item-title class="mb-4"><v-icon size="16">dns</v-icon> Поставщик: {{phone.provider}}</v-list-item-title>
                                        <v-list-item-title class="mb-4"><v-icon size="16">access_time</v-icon> Время захода: {{phone.pages && phone.pages.length > 0 ? phone.pages[0].created_at : ''}}</v-list-item-title>
                                        <v-list-item-title class="mb-4"><v-icon size="16">public</v-icon> Страница: {{phone.pages && phone.pages.length > 0 ? phone.pages[0].url : ''}}</v-list-item-title>
                                        <v-list-item-title class="mb-4" v-if="phone.pages && phone.pages.length > 0 && phone.pages[0].ref">Источник: {{phone.pages && phone.pages.length > 0 ? phone.pages[0].ref : ''}}</v-list-item-title>
                                        <v-list-item-title class="mb-4" v-if="isUTM">UTM-метки:</v-list-item-title>
                                        <v-list-item-subtitle v-for="(utm,key) in phone.utm" :key="key">{{key}}: {{utm}}</v-list-item-subtitle>
                                    </v-list-item-content>
                                </v-list-item>
                            </v-list>
                        </div>
                        <div class="col-md-8">

                            <v-timeline dense clipped>
                                <v-timeline-item
                                        fill-dot
                                        class="white--text"
                                        color="orange"
                                        large
                                >
                                    <template v-slot:icon>
                                        <i class="el-icon-time"></i>
                                    </template>
                                    <h4 class="mt-2">Страницы:</h4>
                                </v-timeline-item>

                                <v-timeline-item
                                        v-for="(page,i) in phone.pages"
                                        :key="i"
                                        class="mb-4"
                                        color="grey"
                                        icon="access_time"

                                        small
                                >
                                    <v-row justify="space-between">
                                        <v-col cols="10"><strong>Заголовок:</strong> {{page.title}}<br/><strong>Страница:</strong> {{page.url}}<br/><span v-if="i == 0 && page.ref"><strong>Источник:</strong> {{page.ref}}</span></v-col>
                                        <v-col class="text-right" cols="2">{{page.created_at}}</v-col>
                                    </v-row>
                                </v-timeline-item>
                            </v-timeline>
                        </div>
                    </div>
                </v-card-text>
                <v-card-text v-else>
                    <div class="text-center my-12">
                        <v-progress-circular
                                :size="50"
                                color="primary"
                                indeterminate
                        ></v-progress-circular>
                    </div>
                </v-card-text>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
    import {mapGetters,mapActions} from 'vuex'

    export default {
        data() {
            return {
                selectSite: null,
                selectProvider: null,
                search: '',
                dialog: false,
                isLoading: false,
                isLoadingDialog: false,
                headers: [
                    {
                        text: 'Id',
                        align: 'left',
                        sortable: true,
                        value: 'id'
                    },
                    {
                        text: 'Сайт',
                        align: 'left',
                        sortable: true,
                        value: 's_title'
                    },
                    {
                        text: 'Номер',
                        align: 'left',
                        sortable: true,
                        value: 'phone'
                    },
                    {
                        text: 'Поставщик',
                        align: 'left',
                        sortable: true,
                        value: 'p_title'
                    },
                    {
                        text: 'Дата визита',
                        align: 'left',
                        sortable: true,
                        value: 'visit_time'
                    },
                    {
                        text: 'Дата получения номера',
                        align: 'left',
                        sortable: true,
                        value: 'created_at'
                    },
                    {
                        text: '',
                        align: 'left',
                        sortable: true,
                        value: 'buttons'
                    }
                ],
                pickerOptions2: {
                    shortcuts: [
                        {
                            text: 'Сегодня',
                            onClick(picker) {
                                const end = new Date();
                                const start = new Date();
                                picker.$emit('pick', [start, end]);
                            }
                        },
                        {
                            text: 'Вчера',
                            onClick(picker) {
                                const end = new Date();
                                const start = new Date();
                                end.setTime(end.getTime() - 3600 * 1000 * 24);
                                start.setTime(start.getTime() - 3600 * 1000 * 24);
                                picker.$emit('pick', [start, end]);
                            }
                        },
                        {
                            text: 'Неделя',
                            onClick(picker) {
                                const end = new Date();
                                const start = new Date();
                                start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                                picker.$emit('pick', [start, end]);
                            }
                        },
                        {
                            text: 'Месяц',
                            onClick(picker) {
                                const end = new Date();
                                const start = new Date();
                                start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                                picker.$emit('pick', [start, end]);
                            }
                        },
                        {
                            text: '3 месяца',
                            onClick(picker) {
                                const end = new Date();
                                const start = new Date();
                                start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                                picker.$emit('pick', [start, end]);
                            }
                        },
                        {
                            text: 'Пол года',
                            onClick(picker) {
                                const end = new Date();
                                const start = new Date();
                                start.setTime(start.getTime() - 3600 * 1000 * 24 * 180);
                                picker.$emit('pick', [start, end]);
                            }
                        },
                        {
                            text: 'Год',
                            onClick(picker) {
                                const end = new Date();
                                const start = new Date();
                                start.setTime(start.getTime() - 3600 * 1000 * 24 * 365);
                                picker.$emit('pick', [start, end]);
                            }
                        }
                    ],
                    firstDayOfWeek: 1
                },
                rangeDates: [],
                datesUrl: ''
            }
        },
        computed: {
            ...mapGetters('Phones', {
                phones: 'GET_PHONES',
                phone: 'GET_PHONE'
            }),
            ...mapGetters('Users', {
                user: 'USER',
            }),
            isUTM() {
                if (this.phone && this.phone.utm) {
                    return Object.values(this.phone.utm).length > 0
                }
                return false
            },
            filteredPhones() {
                return this.phones.filter(phone => {
                    if (phone.phone) {
                        return phone.phone.toLowerCase().indexOf(this.search.toLowerCase()) > -1
                    }
                    return true
                }).filter(phone => {
                    return !this.selectSite || phone.s_title == this.selectSite
                }).filter(phone => {
                    return !this.selectProvider || phone.p_title == this.selectProvider
                })
            },
            sites() {
                let sites = []
                this.phones.forEach(phone => {
                    if (sites.indexOf(phone.s_title) == -1) {
                        sites.push(phone.s_title)
                    }
                })
                return sites
            },
            provides() {
                let providers = []
                this.phones.forEach(phone => {
                    if (providers.indexOf(phone.p_title) == -1) {
                        providers.push(phone.p_title)
                    }
                })
                return providers
            }
        },
        mounted() {
            let start = new Date()
            start.setDate(start.getDate() - 7)
            let end = new Date()
            this.rangeDates = [start,end]
            this.changeDates()
        },
        methods: {
            ...mapActions('Phones', {
                loadPhones: 'loadPhones',
                loadPhoneInfo: 'loadPhoneInfo'
            }),
            changeDates() {
                if (this.rangeDates !== null)
                {
                    this.datesUrl = 'start='+this.$moment(String(this.rangeDates[0])).format('YYYY-MM-DD')+'&end='+this.$moment(String(this.rangeDates[1])).format('YYYY-MM-DD')
                    this.isLoading = true
                    this.loadPhones(this.datesUrl)
                        .then(() => {
                            this.isLoading = false
                        })
                        .catch(() => {
                            this.isLoading = false
                        })
                }
            },
            phoneInfo(item) {
                console.log(item)
                this.isLoadingDialog = true
                this.dialog = true
                this.loadPhoneInfo(item.id)
                    .then(() => {
                        this.isLoadingDialog = false
                    })
                    .catch(() => {
                        this.isLoadingDialog = false
                    })
            },
        }
    }
</script>

<style>
.mycsv {
    margin: 0;
    padding-top: 8px;
    padding-bottom: 6px;
}
.mysearch {
    width: 300px;
    display: inline-block;
}
</style>